import { render } from "./WCCouponClipButton.vue?vue&type=template&id=49d751b6&scoped=true"
import script from "./WCCouponClipButton.vue?vue&type=script&lang=js"
export * from "./WCCouponClipButton.vue?vue&type=script&lang=js"

import "./WCCouponClipButton.vue?vue&type=style&index=0&id=49d751b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d751b6"]])

export default __exports__